import { ASSET_BASE_URL } from '../constants';

const icon = `${ASSET_BASE_URL}/images/facilitybot_favicon.png`;
const bgCta = `${ASSET_BASE_URL}/images/bg-cta.webp`;
const bannerFacilityBot = `${ASSET_BASE_URL}/images/banner.webp`;
const facilitybotLogo = `${ASSET_BASE_URL}/images/facilitybot-logo.webp`;
const pricingPlansThumbnail = `${ASSET_BASE_URL}/images/pricing-plans-thumbnail.webp`;

// Awards
const greatUserExperienceAward = `${ASSET_BASE_URL}/images/great-user-experience-award.webp`;
const risingStarAward = `${ASSET_BASE_URL}/images/rising-star-2020-award.webp`;
const SIFMAAward = `${ASSET_BASE_URL}/images/sifma-award.webp`;
const asiaPacificAward = `${ASSET_BASE_URL}/images/asia-pacific-award.webp`;

//demo logos
const whatsapp = {
	name: 'Whatsapp',
	src: `${ASSET_BASE_URL}/images/demo/whatsapp.png`,
};
const telegram = {
	name: 'Telegram',
	src: `${ASSET_BASE_URL}/images/demo/telegram.png`,
};
const messenger = {
	name: 'Facebook Messenger',
	src: `${ASSET_BASE_URL}/images/demo/messenger.png`,
};
const workchat = {
	name: 'Facebook Workchat',
	src: `${ASSET_BASE_URL}/images/demo/workchat.png`,
};
const widget = {
	name: 'Web Chat Widget and Web Portal',
	src: `${ASSET_BASE_URL}/images/demo/widget.png`,
};
const ios = {
	name: 'iOS Mobile App',
	src: `${ASSET_BASE_URL}/images/demo/ios.png`,
};
const android = {
	name: 'Android Mobile App',
	src: `${ASSET_BASE_URL}/images/demo/android.png`,
};
const line = {
	name: 'Line',
	src: `${ASSET_BASE_URL}/images/demo/line.png`,
};
const googleChat = {
	name: 'Google Chat',
	src: `${ASSET_BASE_URL}/images/demo/googleChat.png`,
};
const slack = {
	name: 'Slack',
	src: `${ASSET_BASE_URL}/images/demo/slack.webp`,
};
const teams = {
	name: 'Microsoft Teams',
	src: `${ASSET_BASE_URL}/images/demo/teams.webp`,
};
const email = {
	name: 'Email',
	src: `${ASSET_BASE_URL}/images/demo/email.webp`,
};
const viber = {
	name: 'Viber',
	src: `${ASSET_BASE_URL}/images/demo/viber.webp`,
};

//Platform logos sources
const whatsappPlatform = `${ASSET_BASE_URL}/images/platform/whatsapp.png`;
const azurePlatform = `${ASSET_BASE_URL}/images/platform/azure.png`;
const linePlatform = `${ASSET_BASE_URL}/images/platform/line.png`;
const messengerPlatform = `${ASSET_BASE_URL}/images/platform/messenger.png`;
const metabasePlatform = `${ASSET_BASE_URL}/images/platform/metabase.png`;
const restapiPlatform = `${ASSET_BASE_URL}/images/platform/restapi.png`;
const seleniumPlatform = `${ASSET_BASE_URL}/images/platform/selenium.png`;
const telegramPlatform = `${ASSET_BASE_URL}/images/platform/telegram.png`;
const webhooksPlatform = `${ASSET_BASE_URL}/images/platform/webhooks.png`;
const workplacePlatform = `${ASSET_BASE_URL}/images/platform/workplace.png`;
const googleChatPlatform = `${ASSET_BASE_URL}/images/platform/googleChat.png`;
const oauth2Platform = `${ASSET_BASE_URL}/images/platform/oauth2.png`;
const samlPlatform = `${ASSET_BASE_URL}/images/platform/saml.png`;
const loriotPlatform = `${ASSET_BASE_URL}/images/platform/loriot.png`;
const uHooPlatform = `${ASSET_BASE_URL}/images/platform/uhoo.png`;
const jtcPlatform = `${ASSET_BASE_URL}/images/platform/jurong_town.png`;

const mqttPlatform = `${ASSET_BASE_URL}/images/platform/mqtt.webp`;
const smartTechPlatform = `${ASSET_BASE_URL}/images/platform/smart_tech.webp`;
const smartOccupancyPlatform = `${ASSET_BASE_URL}/images/platform/smart_occupancy.webp`;
const dormakabaPlatform = `${ASSET_BASE_URL}/images/platform/dormakaba.webp`;
const skylabPlatform = `${ASSET_BASE_URL}/images/platform/skylab.webp`;
const nodeRedPlatform = `${ASSET_BASE_URL}/images/platform/node_red.webp`;
const swipeTaskPlatform = `${ASSET_BASE_URL}/images/platform/swipetask.webp`;
const slackPlatform = `${ASSET_BASE_URL}/images/platform/slack.webp`;
const teamsPlatform = `${ASSET_BASE_URL}/images/platform/microsoft_teams.webp`;
const zapierPlatform = `${ASSET_BASE_URL}/images/platform/zapier.webp`;
const monnitPlatform = `${ASSET_BASE_URL}/images/platform/monnit.webp`;
const milesightPlatform = `${ASSET_BASE_URL}/images/platform/milesight.webp`;
const sensmaxPlatform = `${ASSET_BASE_URL}/images/platform/sensmax.webp`;
const evercommPlatform = `${ASSET_BASE_URL}/images/platform/evercomm.webp`;
const viberPlatform = `${ASSET_BASE_URL}/images/platform/viber.webp`;
const bacnetPlatform = `${ASSET_BASE_URL}/images/platform/bacnet.webp`;
const proCorePlatform = `${ASSET_BASE_URL}/images/platform/procore.webp`;
const microSoftDynamicsPlatform = `${ASSET_BASE_URL}/images/platform/microsoft365.webp`;
const sapS4Platform = `${ASSET_BASE_URL}/images/platform/sap_s4.webp`;
const lionsBotPlatform = `${ASSET_BASE_URL}/images/platform/lionsbot.webp`;
const hytronPlatform = `${ASSET_BASE_URL}/images/platform/hytron.webp`;
const gaussianPlatform = `${ASSET_BASE_URL}/images/platform/gaussian.webp`;
const metaBotsPlatform = `${ASSET_BASE_URL}/images/platform/metabot.webp`;

//illustration images
const illustrations_2 = `${ASSET_BASE_URL}/images/illustrations/illustrations_2.webp`;
const illustrations_3 = `${ASSET_BASE_URL}/images/illustrations/illustrations_3.webp`;
const illustrations_4 = `${ASSET_BASE_URL}/images/illustrations/illustrations_4.webp`;

// security status images
const risk_profile = `${ASSET_BASE_URL}/images/security-status/risk_profile.png`;
const product_security = `${ASSET_BASE_URL}/images/security-status/product_security.png`;
const reports = `${ASSET_BASE_URL}/images/security-status/reports.png`;
const data_security = `${ASSET_BASE_URL}/images/security-status/data_security.png`;
const app_security = `${ASSET_BASE_URL}/images/security-status/app_security.png`;
const access_control = `${ASSET_BASE_URL}/images/security-status/access_control.png`;
const infrastructure = `${ASSET_BASE_URL}/images/security-status/infrastructure.png`;
const security_grades = `${ASSET_BASE_URL}/images/security-status/security_grades.png`;
const endpoint_security = `${ASSET_BASE_URL}/images/security-status/endpoint_security.png`;
const network_security = `${ASSET_BASE_URL}/images/security-status/network_security.png`;
const policies = `${ASSET_BASE_URL}/images/security-status/policies.png`;
const customer_data = `${ASSET_BASE_URL}/images/security-status/customer_data.png`;

// HotDesks gif
const place_desks = `${ASSET_BASE_URL}/images/gif/place_desks.gif`;
const set_permissions = `${ASSET_BASE_URL}/images/gif/set_permissions.gif`;
const book_desk = `${ASSET_BASE_URL}/images/gif/book_desk.webp`;

// Country flags
const indiaFlag = `${ASSET_BASE_URL}/images/india_flag.webp`;
const thailandFlag = `${ASSET_BASE_URL}/images/thailand_flag.webp`;
const malaysiaFlag = `${ASSET_BASE_URL}/images/malaysia_flag.webp`;
const southAfricaFlag = `${ASSET_BASE_URL}/images/south_africa_flag.webp`;
const sriLankaFlag = `${ASSET_BASE_URL}/images/sri_lanka_flag.webp`;
const brazilFlag = `${ASSET_BASE_URL}/images/brazil_flag.webp`;
const dubaiFlag = `${ASSET_BASE_URL}/images/dubai_flag.webp`;
const philippinesFlag = `${ASSET_BASE_URL}/images/philippines-flag.webp`;

// Slack gifs
const createReportFault = `${ASSET_BASE_URL}/images/gif/create_report_fault.gif`;
const createServiceRequest = `${ASSET_BASE_URL}/images/gif/create_service_request.gif`;
const bookHotdesks = `${ASSET_BASE_URL}/images/gif/book_desk.webp`;
const bookFacilities = `${ASSET_BASE_URL}/images/gif/book_facilities.gif`;
const inviteVisitors = `${ASSET_BASE_URL}/images/gif/invite_visitors.gif`;
const slackGuide = `${ASSET_BASE_URL}/images/slack-guide.webp`;

// Versus Competitor
const userImg = `${ASSET_BASE_URL}/images/user-img.webp`;
const messagingImg = `${ASSET_BASE_URL}/images/messaging-img.webp`;
const integrationImg = `${ASSET_BASE_URL}/images/integration-img.webp`;
const versusCompetitorHero = `${ASSET_BASE_URL}/images/versus-competitor-hero.webp`;

export {
	icon,
	bgCta,
	bannerFacilityBot,
	facilitybotLogo,
	pricingPlansThumbnail,
	greatUserExperienceAward,
	risingStarAward,
	SIFMAAward,
	asiaPacificAward,
	whatsapp,
	telegram,
	messenger,
	workchat,
	widget,
	ios,
	android,
	line,
	googleChat,
	slack,
	teams,
	email,
	viber,
	whatsappPlatform,
	azurePlatform,
	linePlatform,
	messengerPlatform,
	metabasePlatform,
	restapiPlatform,
	seleniumPlatform,
	telegramPlatform,
	webhooksPlatform,
	workplacePlatform,
	mqttPlatform,
	smartTechPlatform,
	smartOccupancyPlatform,
	googleChatPlatform,
	dormakabaPlatform,
	skylabPlatform,
	nodeRedPlatform,
	swipeTaskPlatform,
	slackPlatform,
	teamsPlatform,
	zapierPlatform,
	monnitPlatform,
	milesightPlatform,
	sensmaxPlatform,
	evercommPlatform,
	viberPlatform,
	bacnetPlatform,
	jtcPlatform,
	proCorePlatform,
	microSoftDynamicsPlatform,
	oauth2Platform,
	samlPlatform,
	loriotPlatform,
	uHooPlatform,
	sapS4Platform,
	lionsBotPlatform,
	hytronPlatform,
	gaussianPlatform,
	metaBotsPlatform,
	illustrations_2,
	illustrations_3,
	illustrations_4,
	risk_profile,
	product_security,
	reports,
	data_security,
	app_security,
	access_control,
	infrastructure,
	security_grades,
	endpoint_security,
	network_security,
	policies,
	customer_data,
	place_desks,
	set_permissions,
	book_desk,
	indiaFlag,
	thailandFlag,
	malaysiaFlag,
	southAfricaFlag,
	sriLankaFlag,
	brazilFlag,
	dubaiFlag,
	philippinesFlag,
	createReportFault,
	createServiceRequest,
	bookHotdesks,
	bookFacilities,
	inviteVisitors,
	slackGuide,
	userImg,
	messagingImg,
	integrationImg,
	versusCompetitorHero,
};
